export default __webpack_public_path__ + "static/media/target-icon.715d1584.svg";